import React, { useState } from 'react'

import Employment from './Employment'
// import SafeGuarding from './SafeGuarding'
import Policies from './policies/Policies'
import TrainingRecord from './TrainingRecord'
import UITabBar from '../../components/UI/UITabBar'
import ProfileInformation from './ProfileInformation'
import SafeGuardingRecords from './SafeGuardingRecords'

const MyScrRecords = () => {
  const [activeTab, setActiveTab] = useState<string>('Profile Information')

  const handlePressTab = (tab: string) => {
    setActiveTab(tab)
  }

  const storedPermissions = localStorage.getItem('userPermissions')
  const checkPolicy = JSON.parse(storedPermissions ? storedPermissions : '')

  const baseTitles = [
    'Profile Information',
    'Employment',
    'Safeguarding',
    'Training Records',
    'Notes',
  ]

  const policyTitles = [...baseTitles, 'Policies']

  const titles = checkPolicy.includes('Policy') ? policyTitles : baseTitles

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-5 '
      }
    >
      <div
        style={{
          height: 'calc(100vh - 100px)',
          overflow: 'auto',
        }}
      >
        <div className={'flex w-full justify-between items-start '}>
          <div className="flex-col w-[50%] gap-[20px]">
            <p className={'text-lg leading-6 text-text2 font-bold'}>
              My SCR Record
            </p>
            <p className={'text-sm leading-6 font-normal text-text1 mt-2'}>
              This is where all of your information is gathered. You can get a
              full overview of all the completed and outstanding details needed
              for your record.
            </p>
          </div>
        </div>
        <UITabBar
          titles={titles}
          activeTab={activeTab}
          onPressTab={handlePressTab}
          containerStyle="mt-4"
          activeTabText="text-text2"
        />
        {activeTab == 'Profile Information' && <ProfileInformation />}
        {activeTab == 'Employment' && <Employment />}
        {activeTab == 'Safeguarding' && <SafeGuardingRecords />}
        {activeTab == 'Training Records' && <TrainingRecord />}
        {activeTab == 'Policies' && <Policies />}
      </div>
    </div>
  )
}

export default MyScrRecords
